import SellEstimate from "./sellEstimateRansom";
import clsx from "clsx";
import style from "../styles.module.scss";

interface IPossibilitiesEstimateRansomProps {
  isSecondary: boolean;
}

const PossibilitiesEstimateRansom = ({
  isSecondary,
}: IPossibilitiesEstimateRansomProps) => {
  return (
    <div className={style.possibilities}>
      <div className={style.possibilities__container}>
        <div className={clsx(style.possibilities__card)}>
          <div className={style.possibilities__title}>
            <h4>{"Продать:"}</h4>
          </div>
          <div className={style.possibilities__sell}>
            <SellEstimate isSecondary={isSecondary} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PossibilitiesEstimateRansom;
